import { Box, Grid, Typography, useTheme } from "@mui/material";
import { makeStyles } from "@mui/styles";
import {
  ResendVerification,
  ResetPassword,
  SignIn,
  SignUp,
} from "components/user";
import GeoscapeDeveloperSvg from "icons/hub-logo-signIn.svg?react";
import { Redirect, Route, Switch, useLocation } from "react-router";
import * as Routes from "routes";
import { saveRedirectInfo } from "utils/redirect-manager";

import MarketingPage from "./marketing";

const useStyles = makeStyles({
  container: {
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  svg: {
    width: "80vw",
    height: "100px",
    padding: "0px",
  },
});

export const SignedOut = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const classes = useStyles();

  /**
   * App in a signed out state.
   * A simple page layout with a form in center page depending on what route the anonymous user is on.
   */

  const prevLocation = useLocation();
  if (
    prevLocation.pathname !== "/sign-in" &&
    prevLocation.pathname !== "/sign-up" &&
    prevLocation.pathname !== "/"
  ) {
    saveRedirectInfo(prevLocation.pathname, prevLocation.search);
  }

  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      sx={{ minHeight: "100vh", position: "relative" }}
    >
      <Switch>
        <Route exact path={Routes.signIn}>
          <Grid container gap={2} className={classes.container} width="auto">
            <Grid item xs={12} md={12}>
              <GeoscapeDeveloperSvg
                fill={isDark ? "white" : "black"}
                className={classes.svg}
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <SignIn />
            </Grid>
          </Grid>
        </Route>
        <Route exact path={"/"}>
          <Grid container gap={2} className={classes.container}>
            <Grid item xs={12} md={12}>
              <GeoscapeDeveloperSvg
                fill={isDark ? "white" : "black"}
                className={classes.svg}
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <SignIn />
            </Grid>
          </Grid>
        </Route>
        <Route exact path={Routes.signUp}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Grid
              container
              direction="row"
              sx={{ width: "auto", maxWidth: "100%" }}
            >
              <Grid
                item
                xs={12}
                md={6}
                sx={{
                  justifyItems: { xs: "center", md: "flex-end" }, // move closer to center
                }}
              >
                <MarketingPage />
              </Grid>
              <Grid
                item
                xs={12}
                md={6}
                sx={{
                  justifyItems: { xs: "center", md: "flex-start" }, // move closer to center
                }}
              >
                <SignUp />
              </Grid>
            </Grid>
          </Box>
        </Route>
        <Route exact path={Routes.resetPassword}>
          <Grid container gap={2} className={classes.container}>
            <Grid item xs={12} md={12}>
              <GeoscapeDeveloperSvg
                fill={isDark ? "white" : "black"}
                className={classes.svg}
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <ResetPassword />
            </Grid>
          </Grid>
        </Route>
        <Route exact path={Routes.resendVerification}>
          <Grid container gap={2} className={classes.container}>
            <Grid item xs={12} md={12}>
              <GeoscapeDeveloperSvg
                fill={isDark ? "white" : "black"}
                className={classes.svg}
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <ResendVerification />
            </Grid>
          </Grid>
        </Route>
        <Route path="*">
          <Redirect to={Routes.signIn} />
        </Route>
      </Switch>

      <Grid
        item
        xs={12}
        md={12}
        sx={{
          position: "absolute",
          bottom: 0,
          left: 0,
          p: 2,
        }}
      >
        <Typography>
          <sub>v2.0.0.{import.meta.env.VITE_BUILD_NO}</sub>
        </Typography>
      </Grid>
    </Grid>
  );
};
